import { FilterPartialExpression } from '../typings/filter';

export const DEALS_NAVIGATION_GO_TO_FILTER = 'DEALS_NAVIGATION_GO_TO_FILTER';
export type DEALS_NAVIGATION_GO_TO_FILTER = typeof DEALS_NAVIGATION_GO_TO_FILTER;

export interface DealsNavigationGoToFilterAction {
    type: DEALS_NAVIGATION_GO_TO_FILTER;
    expressions: FilterPartialExpression[];
}

export function navToFilter(
    expressions: FilterPartialExpression[]
): DealsNavigationGoToFilterAction {
    return {
        type: DEALS_NAVIGATION_GO_TO_FILTER,
        expressions
    };
}

export type DealsNavigationAction = DealsNavigationGoToFilterAction;
